<div class="separador"> </div>

<div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <div class="navbar-light bg-light border-right" id="sidebar-wrapper">
      <div class="sidebar-heading">{{fecdia | date: 'dd/MM/yyyy'}}</div>
      <div class="sidebar-heading"></div>
      <div class="sidebar-heading"></div>
      <div class="list-group list-group-flush">
        <a class="list-group-item list-group-item-action bg-light"
                 [routerLink]="mnu.ruta"  
              *ngFor="let mnu of menu; let i=index">
              <fa-icon [icon]="mnu.icono"></fa-icon> 
             {{mnu.nombre}}
        </a>
      </div>
    </div>
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav class="navbar navbar-expand-lg navbar-light bg-cave border-bottom">
                <button class="btn  btn-light" (click)="persiana()" id="menu-toggle"><span class="navbar-toggler-icon"></span></button>
                <span class="usuario">{{nomusu}} </span>                 
      </nav>
      <div class="container-fluid">
        <div class="titular">
             <h1>Ficha de Capital</h1>
             <hr>
        </div>
        <div class="selector">
             <div style="width:150px;">
                    <button  class="btn btn-cave btn-block" (click)="volver()">
                        <fa-icon [icon]="icoRet"></fa-icon>  Volver
                     </button>
             </div>
        </div>
        <div style="text-align: center;">
             <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
        </div>

        <div class="inner-container" style="margin-top:10px;">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  id="tabla" class="table table-bordered row-border hover">
            <thead>
              <tr>
                <th >Fecha</th>
                <th >Concepto</th>
                <th >Arrobas Tintas</th>
                <th >Arrobas Blancas</th>
                <th >Capital Suscrito</th>
                <th >Capital Desemb.</th>
                <th >Pendiente Parcial</th>
                <th >Pendiente Total</th>
              </tr>
            </thead> 
            <tbody>
              <tr *ngFor="let dato of datosTabla"> 
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}">{{ dato.cpFecha }}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}">{{ dato.cpConce }}</td> 
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpArbTi | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpArbBl | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpSuscr | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpDesem | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpPdPar | number: '.2'}}</td>
                <td [ngClass]="{'stotal': dato.cpConce === '   TOTALES'}" class="numero">{{ dato.cpPdTot | number: '.2'}}</td> 
              </tr> 
            </tbody> 
          </table>
        </div>
      </div>
</div>
    <!-- /#page-content-wrapper -->
  </div>
  



